import React from "react";
import './footer.css'

export const Footer = () => {

    return <div id="footer">
        Designed and Developed by <a href="https://www.linkedin.com/in/semihayyildiz/" target='_blank'>Semih AYYILDIZ</a>
    </div>
}